import { LuEqual } from 'react-icons/lu'
import { MdExpandLess, MdExpandMore } from 'react-icons/md'

export function ChevronsDown (): JSX.Element {
  return (
    <div style={{ position: 'relative' }}>
      <MdExpandMore size='1.2rem' />
      <MdExpandMore
        size='1.2rem'
        style={{ position: 'absolute', top: '6px', left: 0 }}
      />
    </div>
  )
}

export function ChevronsUp (): JSX.Element {
  return (
    <div style={{ position: 'relative' }}>
      <MdExpandLess size='1.2rem' />
      <MdExpandLess
        size='1.2rem'
        style={{ position: 'absolute', top: '6px', left: 0 }}
      />
    </div>
  )
}

export const sing = (positionDiff: number): JSX.Element | null => {
  if (positionDiff > 0) {
    if (positionDiff >= 2) {
      return <ChevronsUp />
    }
    return <MdExpandLess size='1.2rem' />
  }
  if (positionDiff === 0) {
    return <LuEqual size='1.2rem' />
  }
  if (positionDiff < 0) {
    if (positionDiff <= -2) {
      return <ChevronsDown />
    }
    return <MdExpandMore size='1.2rem' />
  }
  return null
}
